import actionTypes from '../../../../redux/actions/types';
import * as Events from '../../events.js';

const actionsMap = {
  [actionTypes.MYB_PURCHASE]: (state, action) => {
    return Events.managePurchase(state, action);
  },
};

export default function tracker(state, action) {
  const fn = actionsMap[action.type];
  if (fn) {
    return fn(state, action);
  } else {
    return null;
  }
}
